export default {
  children: 'Можна',
  children_under_6: 'Діти до 6',
  without_children: 'Без дітей',
};
